import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  content:any = {};
  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    let slug = this.router.url;
    slug = slug.replace("/","");
    let sid = localStorage.getItem("sid");
    let userData = JSON.parse(localStorage.getItem("currentUser"));
    //console.log(userData.area_id)
    this.spinnerService.show();
      this.auth.conetent({"slug":slug}).then((user) => {
        let response = user.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.spinnerService.hide();
          this.content = user.json().data;
        }
      })
      .catch((err) =>{
        this.spinnerService.hide();
        this.auth.open(environment.error);
      });
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/about/about.component.ts